/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { useTheme } from '@providers/theme';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import {
  HeroSection,
  EditProfileModal,
  UpdateModal,
  AppCardListComp,
  SettingsComp,
  Header,
  BackArrowComp,
} from '../components';
import { vappContainer } from '@/application';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import {
  useSMHoldersListPage,
  useSMPolicyListPage,
  useSMupdateProfile,
  useSMupdateKycStatus,
} from '@pages/HoldersDetailPage/machines';
import { HolderDetailPageService } from '@pages/HoldersDetailPage/services';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import toast from 'react-hot-toast';
import { SearchFilter } from '../../../widgets/filter-widget-react';

const getSrv = () => {
  return vappContainer.get<HolderDetailPageService>(
    HolderDetailPageService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const [showModal, setShowModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [refreshPagination, setReFreshPagination] = useState(new Date());
  const theme = useTheme();
  const srv = getSrv();

  const { updateKycStatusMachine, updateKycStatusSend, updateKycStatusState } =
    useSMupdateKycStatus({});

  const { holderslistPageMachine, holderslistPageState, holderslistPageSend } =
    useSMHoldersListPage({});
  const { policyListPageMachine, policyListPageState, policyListPageSend } =
    useSMPolicyListPage({});
  console.log('appcard', holderslistPageState?.event?.data?.value);

  const onError = () => {
    holderslistPageSend('TRIGGER_REFRESH', {});
    policyListPageSend('REFRESH_POLICY_LIST', {});
  };
  const onButtonPress = (key: string) => {
    if (key === 'updateKyc') {
      if (!updateModal) {
        setUpdateModal(true);
      }
    }
  };
  const onApplyFilter = (data: any) => {
    console.log('on applyfilter', data);
    let criteria = {};
    criteria = {
      ...data,
    };

    holderslistPageSend('TRIGGER_REFRESH', {
      criteria: criteria,
    });
  };

  const onRefresh = () => {
    policyListPageSend('REFRESH_POLICY_LIST', {});
    setReFreshPagination(new Date());
  };

  const onPageRefresh = () => {};
  const onClearFilter = () => {
    holderslistPageSend('TRIGGER_REFRESH', {});
    policyListPageSend('REFRESH_POLICY_LIST', {});
  };

  const _renderNotifications = () => {
    if (updateKycStatusState?.matches('UPDATE_KYC_SUCCESS')) {
      const notificationData = srv?.agent?.getstaticHolderDetailSync()
        ?.notifications?.updateProfileSuccess || {
        title: 'Woo hoo!',
        icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/happy-face-fhp.png',
        description: ['Profile has been updated Successfully'],
        acknowledgementButtonText: 'Close',
      };

      return (
        <NotificationModal
          showModal={true}
          {...notificationData}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }

    return null;
  };

  const updateKycStatus = (data: any) => {
    console.log(`Kyc Status`, data);
    if (updateModal) {
      setUpdateModal(false);
    }
    updateKycStatusSend('START', {
      payload: {
        ...data,
      },
    });
  };

  const _renderModal = () => {
    if (updateModal) {
      return (
        <TweetyModal
          key={`${new Date()}`}
          show={true}
          //size={"md"}
          scrollable={false}
          backdrop={'static'}
          submitButtonTitle={'Update'}
          onSubmit={updateKycStatus}
          onHide={() => setUpdateModal(false)}
          title={'Update Kyc Status'}
          tweetyWidgetProps={{
            fields: srv?.agent?.getstaticHolderDetailSync()?.kycForm?.FIELDS,
            layout: srv?.agent?.getstaticHolderDetailSync()?.kycForm?.layout,
            dynamicLayout:
              srv?.agent?.getstaticHolderDetailSync()?.kycForm?.dynamicLayout,
          }}
        />
      );
    }
  };

  const _renderMainHeader = () => {
    return (
      <>
        <Header {...(srv?.agent?.getstaticHolderDetailSync()?.header || {})} />
      </>
    );
  };

  const onPaginationChange = (event: any) => {
    policyListPageSend('REFRESH_POLICY_LIST', {
      offset: event?.selected * 12,
      size: 12,
    });
  };

  const _renderPagination = () => {
    if (!policyListPageState?.event?.data?.value?.isEmpty) {
      return (
        <Paginate
          {...(policyListPageState?.event?.data?.value || {})}
          onPageChange={onPaginationChange}
          key={refreshPagination}
          totalItems={
            policyListPageState?.event?.data?.value?.appCardList?.length
          }
        />
      );
    }
  };

  const _renderHeader = () => {
    if (srv?.agent?.getstaticHolderDetailSync()?.header) {
      return (
        <>
          <Header
            {...(srv?.agent?.getstaticHolderDetailSync()?.appHeader || {})}
            onRefreshClick={onRefresh}
          />
        </>
      );
    }
    return null;
  };

  const _renderPolicyList = () => {
    if (policyListPageState?.matches('GET_POLICY_LIST')) {
      return (
        <StateOSD
          {...(srv?.agent?.getLoadingHolderDetailSync()?.loading?.policyList ||
            {})}
        />
      );
    }
    if (policyListPageState?.matches('GET_POLICY_LIST_SUCCESS')) {
      return (
        <>
          {policyListPageState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(srv?.agent?.getLoadingHolderDetailSync()?.loading
                ?.credentialListEmpty || {})}
            />
          ) : (
            <AppCardListComp
              {...(policyListPageState?.event?.data?.value || {})}
              onCardClick={props?.onCardClick}
              emptyListProps={
                srv?.agent?.getLoadingHolderDetailSync()?.loading
                  ?.credentialListEmpty
              }
            />
          )}
        </>
      );
    }
  };
  const _renderHolderList = () => {
    if (updateKycStatusState?.matches('UPDATE_KYC')) {
      return (
        <StateOSD
          {...(srv?.agent?.getLoadingHolderDetailSync()?.loading
            ?.updateKycStatus || {
            image:
              'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
            titleNormalText: 'Updating',
            titleBoldText: 'Know Your Customer (KYC) status...',
            description: 'This might take few seconds, Please wait !',
          })}
        />
      );
    }
    if (holderslistPageState?.matches('RENDER_HOLDERS_DETAIL')) {
      return (
        <>
          {_renderMainHeader()}
          <HeroSection
            {...(holderslistPageState?.event?.data?.value || {})}
            onHeroButtonClick={onButtonPress}
          />
          <hr></hr>
          {_renderHeader()}
          {_renderPolicyList()}
        </>
      );
    }
    if (holderslistPageState?.matches('GET_HOLDERS_DETAIL')) {
      return (
        <StateOSD
          {...(srv?.agent?.getLoadingHolderDetailSync()?.loading
            ?.loadingProfile || {
            image:
              'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
            titleNormalText: 'Retrieving ',
            titleBoldText: 'Policy holder profile...',
            description: 'This might take few seconds, Please wait !',
          })}
        />
      );
    }
    return null;
  };

  if (updateKycStatusState?.matches('UPDATE_KYC')) {
    return (
      <StateOSD
        {...(srv?.agent?.getLoadingHolderDetailSync()?.loading
          ?.updateKycStatus || {
          image:
            'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
          titleNormalText: 'Updating',
          titleBoldText: 'Know Your Customer (KYC) status...',
          description: 'This might take few seconds, Please wait !',
        })}
      />
    );
  }

  const _renderErrorModals = () => {
    console.log(
      'updateKycStatusState bool',
      updateKycStatusState?.matches('UPDATE_KYC_FAILED')
    );
    if (updateKycStatusState?.matches('UPDATE_KYC_FAILED')) {
      console.log(
        'updateKycStatusState srv123',
        srv?.agent?.getErrorHolderDetailSync()?.error
      );
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getErrorHolderDetailSync()?.error?.updateProfile ||
            {})}
          onAcknowledgement={onError}
          onDeny={onError}
        />
      );
    }
    if (holderslistPageState?.matches('RENDER_HOLDERS_DETAIL_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getErrorHolderDetailSync()?.error?.getGroup || {})}
          onAcknowledgement={onError}
          onDeny={onError}
        />
      );
    }
  };
  const _renderSearch = () => {
    return (
      <SettingsComp
        {...srv?.agent?.getsettingsHolderDetailSync()?.settings}
        onApplyFilter={onApplyFilter}
        onClearFilter={onClearFilter}
      />
    );
  };

  const _renderBackHeader = () => {
    return <BackArrowComp />;
  };

  const _renderPage = () => {
    return (
      <>
        {_renderBackHeader()}
        {_renderHolderList()}
        {_renderModal()}
        {_renderErrorModals()}
        {_renderNotifications()}
        {_renderPagination()}
      </>
    );
  };
  return <>{_renderPage()}</>;
};
